import Phaser from 'phaser';
import Menu from './Menu';

export default class Preloader extends Phaser.Scene {
	preload() {
		this.load.atlas('tiles', 'assets/map_tiles.png', 'assets/map_tiles.json');
		this.load.atlas('kebab_tiles', 'assets/kebab_tiles.png', 'assets/kebab_tiles.json');
		this.load.audioSprite('sfx', 'assets/sounds/pacman_regular.json', 'assets/sounds/pacman_regular.mp3');
		this.load.audioSprite('bgm', 'assets/sounds/pacman_looped.json', 'assets/sounds/pacman_looped.mp3');
		this.load.image('title', 'assets/title.png');
	}

	create() {
		this.scene.start(Menu.SceneName);
	}
}